// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__h0KOh","employer-overview":"style_employer-overview__9BIq2","employerOverview":"style_employer-overview__9BIq2"};